import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// tslint:disable-next-line:max-line-length
import { MatButtonModule, MatCardModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatFormFieldModule, MatIconModule, MatInputModule, MatRadioModule, MatSelectModule, MatSlideToggleModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ApplicationPipesModule } from '../application-pipes/application-pipes.module';
import { AdminEditComponent } from '../pages/administration-area/admin-edit/admin-edit.component';
import { AlertComponentComponent } from './alert/alert-component/alert-component.component';
import { EliminazioneComponent } from './alert/eliminazione/eliminazione.component';
import { AgendaAvailabilityFormComponent } from './components/agenda-availability-form/agenda-availability-form.component';
import { DisputeComponent } from './components/dispute/dispute.component';
// import { ApiService } from './services/api.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgChatModule } from 'ng-chat';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { BestMatchCardComponent } from './components/best-match-card/best-match-card.component';
import { BuySalespackageCardComponent } from './components/buy-salespackage-card/buy-salespackage-card.component';
import { BuySoftskillCardComponent } from './components/buy-softskill-card/buy-softskill-card.component';
import { ChatComponent } from './components/chat/chat.component';
import { FilesUploaderComponent } from './components/files-uploader/files-uploader.component';
import { ImageCropComponent } from './components/image-crop/image-crop.component';
import { InfoComponent } from './components/info/info.component';
import { NewRatingComponent } from './components/new-rating/new-rating.component';
import { ProfessorCategoryLegendComponent } from './components/professor-categories-legend/professor-categories-legend.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RatingComponent } from './components/rating/rating.component';
import { SalespackageCardComponent } from './components/salespackage-card/salespackage-card.component';
import { SelectPaymentComponent } from './components/select-payment/select-payment.component';
import { SelectProfessorComponent } from './components/select-professor/select-professor.component';
import { ViewAvailabilitiesComponent } from './components/select-professor/view-availabilities/view-availabilities.component';
import { SoftskillCardComponent } from './components/softskill-card/softskill-card.component';
import { VariationProposalComponent } from './components/variation-proposal/variation-proposal.component';
import { VideocallComponent } from './components/videocall/videocall.component';
import { VievProfessorCurriculumComponent } from './components/view-professor-curriculum/view-professor-curriculum.component';
import { SecurePipe } from './pipes/secure.pipe';
import { ErrorHandlerService } from './services/error-handler.service';
import { StorageService } from './services/storage.service';
import { EstimationComponent } from './components/estimation/estimation.component';
import { UserFormTacAndPacComponent } from './components/user-form-tac-and-pac/user-form-tac-and-pac.component';
import { ProfessorCategoryComponent } from './components/professor-category/professor-category.component';

@NgModule({
  declarations: [
    ProfileComponent,
    SecurePipe,
    AdminEditComponent,
    ImageCropComponent,
    AlertComponentComponent,
    FilesUploaderComponent,
    EliminazioneComponent,
    SalespackageCardComponent,
    SoftskillCardComponent,
    BuySalespackageCardComponent,
    BuySoftskillCardComponent,
    BestMatchCardComponent,
    ProfessorCategoryComponent,
    RatingComponent,
    DisputeComponent,
    AgendaAvailabilityFormComponent,
    SelectPaymentComponent,
    SelectProfessorComponent,
    VariationProposalComponent,
    ViewAvailabilitiesComponent,
    InfoComponent,
    ProfessorCategoryLegendComponent,
    VievProfessorCurriculumComponent,
    NewRatingComponent,
    VideocallComponent,
    ChatComponent,
    UserFormTacAndPacComponent,
    EstimationComponent
  ],
  entryComponents: [
    ProfileComponent,
    AdminEditComponent,
    ImageCropComponent,
    AlertComponentComponent,
    EliminazioneComponent,
    DisputeComponent,
    AgendaAvailabilityFormComponent,
    RatingComponent,
    ViewAvailabilitiesComponent,
    SelectProfessorComponent,
    SelectPaymentComponent,
    VariationProposalComponent,
    InfoComponent,
    ProfessorCategoryLegendComponent,
    VievProfessorCurriculumComponent,
    NewRatingComponent,
    VideocallComponent,
    ChatComponent,
    EstimationComponent
  ],
  imports: [
    DragDropModule,
    CommonModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatRadioModule,
    // NG-CHAT
    NgChatModule,
    NgxQRCodeModule,
    ApplicationPipesModule,
    AngularEditorModule,
    MatExpansionModule
  ],
  exports: [
    UserFormTacAndPacComponent,
    MatDialogModule,
    AngularEditorModule,
    SecurePipe,
    FilesUploaderComponent,
    SalespackageCardComponent,
    SoftskillCardComponent,
    BuySalespackageCardComponent,
    BuySoftskillCardComponent,
    BestMatchCardComponent,
    ProfessorCategoryComponent,
    RatingComponent,
    DisputeComponent,
    AgendaAvailabilityFormComponent,
    SelectPaymentComponent,
    SelectProfessorComponent,
    VariationProposalComponent,
    InfoComponent,
    ProfessorCategoryLegendComponent,
    VievProfessorCurriculumComponent,
    VideocallComponent,
    ChatComponent,
    EstimationComponent
  ],
  providers: [
    StorageService,
    ErrorHandlerService,
  ],
})
export class SharedModule { }
